const modifiedFields = ['items2'];
const modifiedFieldCustom = {

};
const sortByFields = {
  items2: ['id'],
  orderBy: ['asc']
};
export default { modifiedFields, modifiedFieldCustom, sortByFields };
